var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#F8F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 9.25L16.75 5.5V14.5L3.25 11.5V9.25Z",
    stroke: "#0064E0",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70077 13.6004C9.62198 13.886 9.4877 14.1533 9.3056 14.3871C9.1235 14.6208 8.89715 14.8164 8.63947 14.9626C8.38178 15.1089 8.09782 15.2029 7.80378 15.2394C7.50975 15.2759 7.2114 15.2542 6.92577 15.1754C6.64015 15.0966 6.37284 14.9623 6.13911 14.7802C5.90538 14.5981 5.7098 14.3718 5.56355 14.1141C5.4173 13.8564 5.32323 13.5724 5.28672 13.2784C5.25022 12.9844 5.27198 12.686 5.35077 12.4004",
    stroke: "#0064E0",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadCast);
export default __webpack_public_path__ + "static/media/BroadCast.5ded2b2844db9518a483b610991eccf2.svg";
export { ForwardRef as ReactComponent };